export const SET_MEETING_TYPE = "SET_MEETING_TYPE";
export const DEFAULT_SELECTED_MEETING_TYPE = "DISCUSSION_MEETING";

const INITIAL_STATE = {
  selectedMeetingType: DEFAULT_SELECTED_MEETING_TYPE,
};

// eslint-disable-next-line default-param-last
const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_MEETING_TYPE:
      return { ...state, selectedMeetingType: action.payload.type };
    default:
      return { ...state };
  }
};

export default reducer;
